

import { API_CENTRE } from "../config";
import _o2sService from "../_o2sServices";
import { IFilter } from "../../models/filters/filter";
import { ISanitaryProtocolFilter } from "../../models/filters/sanitaire/sanitaryProtocolFilter";
import { ISanitaryProtocolForm } from "../../models/forms/sanitaire/sanitaryProtocolForm";
import { ISanitaryProtocolPDTO } from "../../models/dtos/sanitaire/sanitaryProtocolPDTO";

export default class SanitaryProtocolService extends _o2sService {

    protected static override mainUrl:string = API_CENTRE + "/api/v1/SanitaryProtocol";

    protected static override  getUrlFilter<F extends ISanitaryProtocolFilter>(filter?: F):string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null)
        {
            if(filter.centerId != undefined)
                url += `&CenterId=${filter.centerId}`;
            if(filter.name != undefined)
                url += `&Name=${filter.name}`;
            if(filter.typeProtocolId != undefined)
                url += `&TypeProtocolId=${filter.typeProtocolId}`;
        }

        return url;
    }

    public static override toDTO(obj:ISanitaryProtocolForm):ISanitaryProtocolPDTO {
        const dto = super.toDTO(obj) as ISanitaryProtocolPDTO;
        return dto;
    }
}
